import {
  EMI_SCHEME_ADD_REQUEST,
  EMI_SCHEME_ADD_REQUEST_SUCCESS,
  EMI_SCHEME_ADD_REQUEST_FAILURE,
  EMI_SCHEME_FETCH_REQUEST,
  EMI_SCHEME_FETCH_REQUEST_SUCCESS,
  EMI_SCHEME_FETCH_REQUEST_FAILURE,
  EMI_SCHEME_CLEAN_REQUEST,
  EMI_SCHEME_TYPES_FETCH_REQUEST,
  EMI_SCHEME_TYPES_FETCH_REQUEST_SUCCESS,
  EMI_SCHEME_TYPES_FETCH_REQUEST_FAILURE,
  EMI_SCHEME_TYPES_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const SCHEME_DETAIL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const emiSchemesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case EMI_SCHEME_FETCH_REQUEST:
    case EMI_SCHEME_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case EMI_SCHEME_FETCH_REQUEST_SUCCESS:
    case EMI_SCHEME_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case EMI_SCHEME_FETCH_REQUEST_FAILURE:
    case EMI_SCHEME_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case EMI_SCHEME_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export const emiSchemeTypesReducer = (state, action) => {
  state = state || SCHEME_DETAIL_INITIAL_STATE;

  switch (action.type) {
    case EMI_SCHEME_TYPES_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case EMI_SCHEME_TYPES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case EMI_SCHEME_TYPES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case EMI_SCHEME_TYPES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default emiSchemesReducer;
